import PodcastLegacyPage from './PodcastLegacyPage';

export default PodcastLegacyPage;
